import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CkeditorImageDeleteDirective } from './ckeditor-image-delete.directive';



@NgModule({
  declarations: [CkeditorImageDeleteDirective],
  exports: [CkeditorImageDeleteDirective],
  imports: [
    CommonModule
  ]
})
export class CkeditorImageDeleteModule { }
